module.exports = __webpack_public_path__ + "img/ring_g_0_0_null@3x.e431f736.png";